module.exports = __webpack_public_path__ + "static/media/united-kingdom-icon.0eb3abb3.svg";